import React, { useMemo } from 'react';
import ImgPicture from './img-picture';
const LatestItem = ({ latestItem }) => {
    const idName = useMemo(() => {
        return `NEW_${latestItem.image_name}`;
    }, [
        latestItem
    ]);
    return (React.createElement("div", { className: "column-item " },
        React.createElement("div", { className: "column-item-image" },
            React.createElement("a", { href: latestItem.url, target: "_blank", id: idName },
                React.createElement(ImgPicture, { fileName: `./assets/img/latest-item/${latestItem.image_name}`, alt: latestItem.name, ext: 'jpg', lazyload: true }))),
        React.createElement("div", { className: "column-item-name" },
            React.createElement("a", { href: latestItem.url, target: "_blank", "data-label-hover": "\u516C\u5F0F\u30B5\u30A4\u30C8\u3078", id: idName }, latestItem.name))));
};
export default LatestItem;
